// ** React Imports
import { ReactNode, useState } from 'react'

// ** MUI Imports
import Card from '@mui/material/Card'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'

// ** Icon Imports
import Icon from 'src/@core/components/icon'
import { Box, Stack } from '@mui/material'
import {CardActionsStyles} from "./CardActions.styles";


interface CardActionCollapseProps {
    children?: ReactNode
    title: ReactNode,
    subtitle?: string
    colapsable?: boolean
    collapsed?: boolean,
    actions?: ReactNode,
    tableContent?: boolean
    icon?: string
}


interface CardActionCollapseActionsProps {
    actions?: ReactNode
    collapsed: boolean
    setCollapsed: any
    colapsable?: boolean
}


const CardActionCollapseActions = (props: CardActionCollapseActionsProps) => {
    return (
        <Stack direction={'row'} spacing={2} alignItems='center'>
            {props.actions}
            {props.colapsable &&
                <IconButton
                    size='small'
                    aria-label='collapse'
                    sx={{ color: 'text.secondary' }}
                    onClick={() => props.setCollapsed(!props.collapsed)}
                >
                    <Icon fontSize={30} icon={!props.collapsed ? 'mdi:chevron-down' : 'mdi:chevron-up'} />
                </IconButton>
            }
        </Stack>
    )
}


const CardActions = (props: CardActionCollapseProps) => {
    const classes = CardActionsStyles();
    const [collapsed, setCollapsed] = useState<boolean>(props.collapsed !== undefined ? props.collapsed : true)

    const titleContent = props.icon ? (
        <Stack direction='row' alignItems='center' gap={1.5}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 0.875,
                    borderRadius: '8px',
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                    color: 'primary.main',
                    flexShrink: 0,
                }}
            >
                <Icon icon={props.icon} fontSize='1.2rem' />
            </Box>
            <Typography variant='h6' component='span' sx={{ fontWeight: 700, fontSize: '1rem' }}>
                {props.title}
            </Typography>
        </Stack>
    ) : props.title

    return (
        <Card
            sx={{
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
                transition: 'box-shadow 0.25s ease',
                '&:hover': { boxShadow: '0 4px 18px rgba(0,0,0,0.12)' },
            }}
        >
            <CardHeader
                sx={{
                    py: 1.75,
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    borderBottom: '2px solid',
                    borderBottomColor: (theme) => alpha(theme.palette.primary.main, 0.2),
                    '& .MuiCardHeader-action': { alignSelf: 'center', mt: 0 },
                }}
                title={titleContent}
                action={
                    <CardActionCollapseActions
                        actions={props?.actions}
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                        colapsable={props.colapsable}
                    />
                }
            />
            <Collapse in={collapsed}>
                {/* CardContent p:0 + Box interno garantiza que el pt no sea
                    devorado por el margin-top negativo del Grid container */}
                <CardContent
                    sx={{ p: 0 }}
                    className={`${props.tableContent ? classes.cardTableContent : ''}`}
                >
                    <Box sx={{
                        px: props.tableContent ? 0 : 4,
                        pt: 3,
                        pb: 4,
                    }}>
                        {props.children}
                    </Box>
                </CardContent>
            </Collapse>
        </Card>
    )
}


export default CardActions
